import { Point } from "../DrawingObj";
import { createUUID } from "../../Misc";
import { dxfFloat } from "../NodeDXF/dxfFloat";
import { TYPE_CUT, TYPE_FOLD, TYPE_IGNORE } from "../nodedxf2";
export { Arc } from "./Arc";
export class Element {
    constructor(element) {
        this.element = null;
        this.named = "";
        this.points = [];
        this.Visible = true;
        this.Extrusion = null;
        this.element = element;
        this.named =
            ["LWPOLYLINE", "POLYLINE"].indexOf(element.named) >= 0
                ? "POLYGON"
                : element.named;
        this.id = createUUID();
        this.setType(TYPE_CUT);
        if (this.element.AcDbEntity) {
            this.setType(this.element.AcDbEntity.NAME);
            if (this.element.AcDbEntity.Visible)
                this.Visible = this.element.AcDbEntity.Visible;
            if (this.element.AcDbEntity.ColorNumber)
                this.ColorNumber = this.element.AcDbEntity.ColorNumber;
            delete this.element.AcDbEntity.Visible;
            delete this.element.AcDbEntity.ColorNumber;
        }
    }
    setType(t) {
        switch (t.toUpperCase()) {
            case "BEND":
            case TYPE_FOLD:
                this.Type = TYPE_FOLD;
                break;
            case "OUTER_PROFILES":
            case "INTERIOR_PROFILES":
            case TYPE_CUT:
                this.Type = TYPE_CUT;
                break;
            case "BEND_EXTENT":
            case TYPE_IGNORE:
                this.Type = TYPE_IGNORE;
                break;
            default:
                //  console.log('Unknown Type, setting to TYPE_CUT', t)
                this.Type = TYPE_CUT;
                break;
        }
    }
    maxX(i) {
        if (!this.Visible)
            return i;
        return Math.max(i, ...this.points.reduce((acc, { x }) => [...acc, x], []));
    }
    maxY(i) {
        if (!this.Visible)
            return i;
        return Math.max(i, ...this.points.reduce((acc, { y }) => [...acc, y], []));
    }
    minX(i) {
        if (!this.Visible)
            return i;
        return Math.min(i, ...this.points.reduce((acc, { x }) => [...acc, x], []));
    }
    minY(i) {
        if (!this.Visible)
            return i;
        return Math.min(i, ...this.points.reduce((acc, { y }) => [...acc, y], []));
    }
    ExtrusionCheck() {
        if (this.element.VARS && this.element.VARS.Extrusion) {
            this.Extrusion = new Point();
            this.Extrusion.x = dxfFloat(this.element.VARS.Extrusion[210]);
            this.Extrusion.y = dxfFloat(this.element.VARS.Extrusion[220]);
            this.Extrusion.z = dxfFloat(this.element.VARS.Extrusion[230]);
            //not sure reallt what is going on here, but it seems to be working
            var m = this.Extrusion.z;
            if (this.points)
                this.points = this.points.map((v) => {
                    v.x = v.x * m;
                    return v;
                });
        }
    }
    length() {
        return 0;
    }
}
